import { useEffect, useRef } from "react";
import "../Style/Vm.css";
import { useLanguage } from "../Context/Languagecontext";

export default function Vm() {
  const sectionRef = useRef(null);
  const { t } = useLanguage();

  const vm = t.vm;

  const CARDS = [
    {
      id: "vision",
      mod: "vm-card--vision",
      icon: "👁",
      label: vm.cards.vision.label,
      text: vm.cards.vision.text,
    },
    {
      id: "mission",
      mod: "vm-card--mission",
      icon: "◎",
      label: vm.cards.mission.label,
      text: vm.cards.mission.text,
    },
  ];

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const cards = section.querySelectorAll(".vm-card");
    const circles = section.querySelectorAll(".vm-circle");
    const arcs = section.querySelectorAll(".vm-arc");
    const headers = section.querySelectorAll(
      ".vm-header__eyebrow, .vm-header__title, .vm-header__rule",
    );

    const reset = () => {
      [...cards, ...circles, ...arcs, ...headers].forEach((el) => {
        el.style.animationName = "none";
        el.style.opacity = "";
      });
    };

    const trigger = () => {
      [...cards, ...circles, ...arcs, ...headers].forEach((el) => {
        void el.offsetWidth;
        el.style.animationName = "";
      });
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          reset();
          requestAnimationFrame(() => requestAnimationFrame(trigger));
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`vm-section ${t.lang === "ta" ? "vm-section--tamil" : ""}`}
      ref={sectionRef}
      aria-label="Vision and Mission"
    >
      <div className="vm-bg-ornament" aria-hidden="true" />

      <header className="vm-header">
        <p className="vm-header__eyebrow">{vm.eyebrow}</p>
        <h2 className="vm-header__title">{vm.title}</h2>

        <div className="vm-header__rule" aria-hidden="true">
          <span />
          <i />
          <span />
        </div>
      </header>

      <div className="vm-grid">
        {CARDS.map((card) => (
          <article key={card.id} className={`vm-card ${card.mod}`}>
            <div className="vm-circle-wrap" aria-hidden="true">
              <div className="vm-circle">
                <span className="vm-circle__icon">{card.icon}</span>
                <span className="vm-circle__label">{card.label}</span>
              </div>
            </div>

            <div className="vm-arc-wrap">
              <div className="vm-arc">
                <p className="vm-arc__text">{card.text}</p>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
